import React from 'react';
import { ROUTE_DESTINATIONS, ROUTE_MY_NEXSETS } from 'new/constants/pathnames';
import styles from './NavigatorForEditedNexset.module.scss';
import { ReactComponent as CheckIcon } from 'new/components/icons/check-filled.svg';
import { Button, Typography } from '@mui/material';
import cx from 'classnames';
import { useSelector } from 'react-redux';

interface Props {
  redirectAfterCompletion: (path: string) => void;
  isNexsetDetected?: boolean;
  dataSetId: number;
}

const NavigatorForEditedNexset = ({
  redirectAfterCompletion,
  isNexsetDetected,
  dataSetId,
}: Props) => {
  const destinationDraftRawSamples = useSelector(
    (state: any) => state.recipeBuilder.destinationDraft?.rawSamples,
  );
  const firstSample = destinationDraftRawSamples?.[0];

  return (
    <div className={styles.section}>
      <div className={styles.container}>
        <div
          className={cx(styles.titleContainer, isNexsetDetected ? styles.smallMarginBottom : null)}
        >
          <CheckIcon />
          <h1 className={styles.title}>Destination Created. Schema Change Needed.</h1>
        </div>
        <div className={styles.subTitleContainer}>
          <h2 className={cx(styles.subTitle, isNexsetDetected ? styles.smallMarginBottom : null)}>
            {!isNexsetDetected ? (
              'Proceed to the Nexset Designer and apply schema changes.'
            ) : (
              <>
                Please update your upstream source to match the schema required. A sample of data
                required is shown below.
              </>
            )}
          </h2>
        </div>
        {isNexsetDetected && firstSample && Object.keys(firstSample)?.length > 0 && (
          <pre className={cx(styles.smallMarginBottom, styles.sampleContainer)}>
            {JSON.stringify(firstSample, null, 2)}
          </pre>
        )}
        <div
          className={cx(
            styles.buttonsContainer,
            isNexsetDetected ? styles.buttonsContainerWithOneButton : null,
          )}
        >
          {!isNexsetDetected ? (
            <Button
              variant="outlined"
              onClick={() => redirectAfterCompletion(`${ROUTE_MY_NEXSETS}/${dataSetId}/edit`)}
              className={styles.button}
            >
              <Typography variant="button">Apply Schema Changes</Typography>
            </Button>
          ) : null}

          <Button
            variant="outlined"
            onClick={() => redirectAfterCompletion(ROUTE_DESTINATIONS)}
            className={styles.button}
          >
            <Typography variant="button">
              {!isNexsetDetected ? 'Continue Without Applying' : 'Back to Destinations List'}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};

NavigatorForEditedNexset.formConfig = { title: '' };

export default NavigatorForEditedNexset;
